import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 11v6l-5 -4l-5 4v-6l5 -4l5 4","key":"svg-0"}]]

const IconArrowBadgeUp = createReactComponent('outline', 'arrow-badge-up', 'ArrowBadgeUp', __iconNode);

export default IconArrowBadgeUp;